module.exports = __webpack_public_path__ + "static/tt-desktop-futures-grid-97b10bbbdbd50a8de826f7101aacf427.png";